/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextAlignCenter(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" />
        <Path d="M64,100a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" />
        <Path d="M215.99707,140H40.00293a8,8,0,1,0,0,16H215.99707a8,8,0,0,0,0-16Z" />
        <Path d="M191.99707,180H64.00293a8,8,0,0,0,0,16H191.99707a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default TextAlignCenter;
